export const environment = {
    production: false,
    applicationName: "WeColo",
    // apiUrl: "https://localhost:5001/",
    apiUrl: "https://api.wecolo.fr/",
    //hereApiKey: "L-3dbk1_Y2ufXPAIV0a0483Wv5bC5G3dKKfIVyOct44",
    maxPictureSize: 4000000,
    errorDuration: 3000,
    geoapifyApiKey: "9c23b68a67704224ad7a23f6aad47835",
    maptilerApiKey : "K5OZMEPRc0lC96RhagvZ",
    tilesMapUrl : "https://api.maptiler.com/maps/voyager/{z}/{x}/{y}@2x.png?key="
};
